export const ALERTS_UPDATE_PERIOD = 60000
